// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"44191e31","703":"da644129","787":"f0220c90"}[chunkId] + ".chunk.js";
};